import errorMappingService from '@/services/error-mapping-service';
// custom handlers
import { GlobalValidationErrorHandler } from '@/middlewares/axios/handler/GobalValidationErrorHandler';
import { GlobalConfirmationErrorHandler } from '@/middlewares/axios/handler/GlobalConfirmationErrorHandler';

const isBadRequest = (error) => error.response.status == 400;

const composeErrorWithGlobalBadRequestHandler = (error) => {
  const errorData = error.response.data;

  if (errorMappingService.isValidationError(errorData.message)) {
    error.response.isValidationError = true;
    error.response.handler = new GlobalValidationErrorHandler(errorData.errors);
  }

  if (errorMappingService.isConfirmationError(errorData.message)) {
    error.response.isConfirmationError = true;
    error.response.handler = new GlobalConfirmationErrorHandler(errorData);
  }

  return error;
}

export { isBadRequest, composeErrorWithGlobalBadRequestHandler }
